import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { getMessage } from "@/utils/MessageUtils"
import { isContain } from "@/utils/ParamUtils"
import perms from "@/common/permissions/sale/perms"

class OrderStatus extends React.Component {
  static propTypes = {
    orderStatus: PropTypes.string,
    loginStatus: PropTypes.object,
  }

  render() {
    const { orderStatus, loginStatus } = this.props
    if (!orderStatus) {
      return null
    }
    return loginStatus && loginStatus.authorized && isContain(loginStatus.userPermissions, perms.GRAY_ORDER_FUSION) ? <span>{getMessage(orderStatus, "FusedOrderStatus")}</span> : <span>{getMessage(orderStatus, "OrderStatus")}</span>
  }
}

function mapStateToProps(state, ownProps) {
  return {
    loginStatus: state.loginStatus,
  }
}

export default connect(mapStateToProps)(OrderStatus)
